import { render, staticRenderFns } from "./OrganismInitialAccess.vue?vue&type=template&id=492ed6a8&"
import script from "./OrganismInitialAccess.vue?vue&type=script&lang=js&"
export * from "./OrganismInitialAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports